import Badge from "@/components/base/Badge";
import type { CycleScope } from "@/types";

const mapping: Record<
  CycleScope,
  { tone: "primary" | "warning" | "secondary"; label: string; icon: string }
> = {
  PRIMAIRE: { tone: "warning", label: "Primaire", icon: "ri-leaf-line" },
  SECONDAIRE: { tone: "secondary", label: "Secondaire", icon: "ri-book-2-line" },
  GLOBAL: { tone: "primary", label: "Global", icon: "ri-global-line" },
};

interface CycleBadgeProps {
  scope: CycleScope;
  className?: string;
  withIcon?: boolean;
}

export default function CycleBadge({ scope, className = "", withIcon = true }: CycleBadgeProps) {
  const conf = mapping[scope];
  return (
    <Badge tone={conf.tone} icon={withIcon ? conf.icon : undefined} className={className}>
      {conf.label}
    </Badge>
  );
}
